import { useSelector } from 'react-redux';
import { addHowItWorksData } from '../Redux/actions';
import { getHowItWorksDataSelector } from '../Redux/selectors';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithHowItWorks = ({ children }) => {
  const howItWorksData = useSelector(getHowItWorksDataSelector);

  return (
    <WithFetchJsonContent
      reduxInStore={howItWorksData}
      addToReduxFunction={addHowItWorksData}
      jsonLocation="content/HIW"
    >
      {children}
    </WithFetchJsonContent>
  );
};
